import React from "react";

const FwDropdown = ({
  id,
  label,
  value,
  placeholder,
  options = [],
  openKey,
  setOpenKey,
  onChange,
}) => {
  const isOpen = openKey === id;

  return (
    <div className="fw-dropdown">
      <label
        className="fw-field"
        htmlFor={id}
      >
        <span>{label}</span>

        <button
          id={id}
          type="button"
          className={`fw-dropdown__trigger ${
            isOpen ? "is-open" : ""
          }`}
          onClick={() => {
            setOpenKey(isOpen ? null : id);
          }}
        >
          <span>
            {value || placeholder}
          </span>

          <span
            className={`fw-dropdown__arrow ${
              isOpen ? "is-open" : ""
            }`}
          >
            ▾
          </span>
        </button>
      </label>

      {isOpen && (
        <div className="fw-dropdown__menu">
          {options.map((option) => {
            const optionValue =
              typeof option === "string"
                ? option
                : option.value;

            const optionLabel =
              typeof option === "string"
                ? option
                : option.label;

            return (
              <button
                key={optionValue}
                type="button"
                className={`fw-dropdown__option ${
                  value === optionValue
                    ? "is-selected"
                    : ""
                }`}
                onClick={() => {
                  onChange(optionValue);
                  setOpenKey(null);
                }}
              >
                {optionLabel}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FwDropdown;